export const FormLabel = {
    baseStyle: {
        fontWeight: "600",
    },
    variants: {
        standard: {
            color: "primary.200",
            mt: "6",
        },
        custom: {
            color: "white",
            mt: "0",
        },
    },
    defaultProps: {
        variant: "standard",
    },
};
